import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const warn = (projectId) => {
    // const projectId = localStorage.getItem("project_id");
    return Request({
        method: "get",
        url: `${baseUrl}/projects/${projectId}/warnOwner`,
        needToken: true
    });
};